import styled from 'styled-components';

const ButtonSection = styled.div`
  display: flex;
  gap: var(--space-8);
  padding-top: var(--space-12);
`;

export { ButtonSection };
